import api from '@/api/api';
import { createQueryParams } from '@/utils/createQueryParams';

const DOMAIN = '/blog';

const getAll = async (
	params: Blog.FindBlogPostsQuery,
): Promise<Blog.PaginatedBlogPostList> => {
	const queryParams = createQueryParams({ ...params });
	const { data } = await api.get(`${DOMAIN}?${queryParams}`);
	return data;
};

const getBySlug = async (slug: string): Promise<Blog.BlogPost> => {
	const { data } = await api.get(
		`${DOMAIN}/slug/${encodeURIComponent(slug)}`,
	);
	return data;
};

const getById = async (id: string): Promise<Blog.BlogPost> => {
	const { data } = await api.get(`${DOMAIN}/${id}`);
	return data;
};

const create = async (body: Blog.CreateBlogPost): Promise<Blog.BlogPost> => {
	const { data } = await api.post(DOMAIN, body);
	return data;
};

const update = async (
	id: string,
	body: Blog.UpdateBlogPost,
): Promise<Blog.BlogPost> => {
	const { data } = await api.patch(`${DOMAIN}/${id}`, body);
	return data;
};

const remove = async (id: string): Promise<Blog.BlogPost> => {
	const { data } = await api.delete(`${DOMAIN}/${id}`);
	return data;
};

const BlogService = {
	getAll,
	getBySlug,
	getById,
	create,
	update,
	remove,
};

export { BlogService };
